"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTAINER_ID = exports.BRICKS = void 0;
var _bricksParagraph = require("@titelmedia/bricks-paragraph");
var _bricksSection = require("@titelmedia/bricks-section");
var _bricksGallery = require("@titelmedia/bricks-gallery");
var _bricksLoader = require("@titelmedia/bricks-loader");
var _bricksHeadline = require("@titelmedia/bricks-headline");
var _bricksSvg = require("@titelmedia/bricks-svg");
var _bricksQuote = require("@titelmedia/bricks-quote");
var _bricksCta = require("@titelmedia/bricks-cta");
var _bricksCustomHtml = require("@titelmedia/bricks-custom-html");
var _bricksImages = require("@titelmedia/bricks-images");
var _bricksImageText = require("@titelmedia/bricks-image-text");
var _bricksVideo = require("@titelmedia/bricks-video");
var _bricksInterview = require("@titelmedia/bricks-interview");
var _bricksSeparator = require("@titelmedia/bricks-separator");
var _bricksCredits = require("@titelmedia/bricks-credits");
var _bricksMarquee = require("@titelmedia/bricks-marquee");
var _bricksShoppingCarousel = require("@titelmedia/bricks-shopping-carousel");
var _bricksAgeGate = require("@titelmedia/bricks-age-gate");
var _bricksHero = require("@titelmedia/bricks-hero");
var _bricksArticleAggregator = require("@titelmedia/bricks-article-aggregator");
var _bricksFieldsForm = require("@titelmedia/bricks-fields-form");
const CONTAINER_ID = 'bricks-story';
exports.CONTAINER_ID = CONTAINER_ID;
const BRICKS = {
  elements: {
    Paragraph: _bricksParagraph.Paragraph,
    Gallery: _bricksGallery.Gallery,
    Headline: _bricksHeadline.Headline,
    Quote: _bricksQuote.Quote,
    Separator: _bricksSeparator.Separator,
    Images: _bricksImages.Images,
    Imagetext: _bricksImageText.Imagetext,
    CustomHtml: _bricksCustomHtml.CustomHtml,
    Loader: _bricksLoader.Loader,
    Video: _bricksVideo.Video,
    Interview: _bricksInterview.Interview,
    Credits: _bricksCredits.Credits,
    Marquee: _bricksMarquee.Marquee,
    ShoppingCarousel: _bricksShoppingCarousel.ShoppingCarousel,
    CTA: _bricksCta.CTA,
    SVG: _bricksSvg.SVG,
    Svg: _bricksSvg.SVG,
    Cta: _bricksCta.CTA,
    AgeGate: _bricksAgeGate.AgeGate,
    Hero: _bricksHero.Hero,
    ArticleAggregator: _bricksArticleAggregator.ArticleAggregator,
    FieldsForm: _bricksFieldsForm.FieldsForm
  },
  section: _bricksSection.Section
};
exports.BRICKS = BRICKS;
//# sourceMappingURL=bricks.js.map